import { RootState } from "../store";

export const getMonthlyWeightData = (state: RootState) => state.monthlyWasteWeight.data;
export const getMonthlyWeightStatus = (state: RootState) => state.monthlyWasteWeight.status;
